module.exports = __webpack_public_path__ + "9ce6a1457632949e270520245f528fb7.png";